'use strict';

(function() {

    let map;
    let markers = [];
    let showAllMarkers = true;
    let latestZoomFactor;

    kartor.hamtaSvgRaknare();

    $(document).on('click', '#navbar-toggler-karta.collapsed', function () {
        const kartaLaddad = document.getElementById('karta-laddad').value === 'true';

        const kartaSkaVisas = document.getElementById('karta-livlina');

        if (!kartaLaddad && kartaSkaVisas) {

            kartor.initieraKarta(initMap);

            function initMap() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(skapaKartaMedPosition, function () { skapaKartaMedPosition(null) });
                } else {
                    skapaKartaMedPosition(null);
                }

                document.getElementById('karta-laddad').value = 'true';
            }
        }
    });

    function skapaKartaMedPosition(position) {

        const karta = document.getElementById('karta-livlina');

        const sthlmLat = 59.327261677951526;
        const sthlmLong = 18.071652409999714;

        const gbgLat = 57.70502252808424;
        const gbgLong = 11.965437821304402;

        let lat = sthlmLat;
        let long = sthlmLong;
        let zoom = 12;
        
        if (position == null) {
            console.log('No position from geocoding...');
        }
        else if (position.coords.latitude > 58 &&
            position.coords.latitude < 60 &&
            position.coords.longitude > 17 &&
            position.coords.longitude < 19) {
            lat = sthlmLat;
            long = sthlmLong;
            showAllMarkers = false;
        }
        else if (position.coords.latitude > 56 &&
                 position.coords.latitude < 58 &&
                 position.coords.longitude > 11 &&
            position.coords.longitude < 13) {
            lat = gbgLat;
            long = gbgLong;
            showAllMarkers = false;
        }

        map = kartor.skapaKarta(karta, lat, long, zoom, null, true);

        markeraPlatser();
        latestZoomFactor = map.getZoom();
        google.maps.event.addListener(map, 'zoom_changed', function () {
            
            const mapZoom = map.getZoom();
            if (mapZoom > latestZoomFactor && latestZoomFactor <= kartor.zoomLevelForAttVisaAntal && mapZoom > kartor.zoomLevelForAttVisaAntal) {
                removeMarkers();
                markeraPlatser();
            }
            else if (mapZoom < latestZoomFactor && latestZoomFactor > kartor.zoomLevelForAttVisaAntal && mapZoom <= kartor.zoomLevelForAttVisaAntal) {
                removeMarkers();
                markeraPlatser();

            }

            latestZoomFactor = map.getZoom();
        });
    }

    function markeraPlatser(fitBounds) {
        const markerInfo = document.createElement('marker-info');

        var url = document.getElementById('url-livlina-karta').value;

        fetch(url)
            .then(response => response.text())
            .then(result => {
                markerInfo.innerHTML = result;

                const slideshows = markerInfo.querySelectorAll('.sidhuvud-slideshow');
                af.initSlideshow(slideshows);

                if (document.getElementById('karta-fastigheter').classList.contains('active')) {
                    let fastigheter = markerInfo.querySelectorAll('.card-fastighet');

                    for (let i = 0; i < fastigheter.length; i++) {
                        markeraPlatsOchSkapaPopup(fastigheter[i].dataset.latitud,
                            fastigheter[i].dataset.longitud,
                            kartor.ikonFastighetPrimar,
                            fastigheter[i]);
                    }
                }

                if (document.getElementById('karta-lediga-lokaler').classList.contains('active')) {
                    let lokaler = markerInfo.querySelectorAll('.card-lokal');

                    markers = kartor.markeraLokaler(map, lokaler, markers, false, kartor.ikonLokalPrimar);
                }

                if (document.getElementById('karta-projekt').classList.contains('active')) {
                    let projektlista = markerInfo.querySelectorAll('.card-projekt');

                    for (let i = 0; i < projektlista.length; i++) {
                        markeraPlats(projektlista[i].dataset.latitud,
                            projektlista[i].dataset.longitud,
                            kartor.ikonProjektPrimar,
                            projektlista[i]);
                    }
                }

                if (fitBounds && showAllMarkers) {
                    var bounds = new google.maps.LatLngBounds();
                    for (let i = 0; i < markers.length; i++) {
                        bounds.extend(markers[i].getPosition());
                    }

                    map.fitBounds(bounds);
                }
            });
    }
    function markeraPlatsOchSkapaPopup(latitud, longitud, ikon, htmlobjekt) {

        const popup = kartor.skapaPopupHtmlFranObjekt(htmlobjekt);

        markeraPlats(latitud, longitud, ikon, popup);
    }

    function markeraPlats(latitud, longitud, ikon, htmlPopup) {

        if (latitud !== '' && longitud !== '') {
            let marker = kartor.marker(latitud, longitud, map, ikon);

            kartor.hanteraPopup(map, marker, htmlPopup);

            markers.push(marker);
        }
    }

    $(document).on('click',
        '.kartval',
        function () {
            $(this).toggleClass('active');
            removeMarkers();
            markeraPlatser();
        });

    function removeMarkers() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

    const innehallFastighetssida = document.getElementById('innehall');
    let isFastighetSida = false;
    
    if (innehallFastighetssida && innehallFastighetssida.classList.contains('fastighet-sida')) {
        isFastighetSida = true;
        
    }
    if (!isFastighetSida) {
        hanteraAfterMedgivande();
    }

    function hanteraAfterMedgivande() {
        var openTagetAfterReload = sessionStorage.getItem('opentargetafterreload');
        if (openTagetAfterReload) {
            const targetElement = document.querySelector(openTagetAfterReload);
            targetElement.click();
            sessionStorage.removeItem('opentargetafterreload');
        }
    }
})();



